import React, { Component } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { api } from '../../../components/api/api';

class ModalLogDepositoEstoque extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState
        this.open = (id) => {
            this.getLogs(id)
            this.setState({
                ...this.state,
                id,
                show: true
            })
        }
    }

    getLogs = (id) => {
        const { dtInicio, dtFim } = this.state;
        api.get(`/api/Log/DepositoEstoque/${id}?dateInicio=${dtInicio}&dateFim=${dtFim}`, res => {
            this.setState({
                ...this.state,
                logs: res.data
            })
        })
    }

    initialState = {
        id: 0,
        show: false,
        dtInicio: '',
        dtFim: '',
        logs: []
    }

    onClose = () => {
        this.setState(this.initialState);
    }

    onChangeInputValue = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    };

    render() {
        const { show, dtInicio, dtFim, logs } = this.state;

        return (
            <Modal show={show} centered>
                <Modal.Header>
                    <Modal.Title>Logs de Materia Prima</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={e => { e.preventDefault(); this.getLogs(this.state.id) }}>
                        <Row>
                            <Col>
                                <label>Data Inicio</label>
                                <input required type="date" onChange={this.onChangeInputValue} value={dtInicio} name="dtInicio" className='form-control' />
                            </Col>
                            <Col>
                                <label>Data Fim</label>
                                <input required type="date" onChange={this.onChangeInputValue} value={dtFim} name="dtFim" className='form-control' />
                            </Col>
                            <Col style={{ marginTop: '1rem' }}>
                                <button className='btn btn-primary'>Buscar Logs</button>
                            </Col>
                        </Row>
                    </form>
                    <br /><br />
                    <div style={{ display: 'flex', flexDirection: "column", gap: 5, justifyContent: "center" }}>
                        {logs.map(log => (
                            <div>
                                {log.date} - {log.texto}
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-danger' onClick={() => this.onClose()}>Fechar</button>
                </Modal.Footer>
            </Modal >
        );
    }
}

export default ModalLogDepositoEstoque;